import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_TERMSCONDITION, GET_TERMSCONDITION_BY_ID } from "../constants";

export const getTermsandcondition = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/terms/", { params: data });
    if (response?.data?.status) {
      dispatch({
        type: GET_TERMSCONDITION,
        termsandconditionlist: response?.data?.response,
      });
    } else {
      dispatch({ type: GET_TERMSCONDITION, termsandconditionlist: [] });
    }
  } catch (err) {
   // console.error(err);
    dispatch({ type: GET_TERMSCONDITION, termsandconditionlist: [] });
  }
};

export const addTermsandcondition = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/terms/", data);
    if (response?.data?.status) {
      setLoading(false);
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }

    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const updateTermsandcondition =
  (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/terms/", data);
      if (response?.data?.status) {
        setLoading(false);
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/termscondition")
        return response;
      }
      swal({
        text: response?.data?.response?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    } catch (err) {
     // console.error(err);
    }
  };

export const deleteTermsandcondition = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`admin/terms/${id}`);
    if (response?.data?.status) {
      setLoading(false);
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      window.location.reload()
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getTermsandconditionById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/terms/${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_TERMSCONDITION_BY_ID,
        termsandconditionbyid: response.data.response,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
  }
};
